import React from 'react';
import { useBreadcrumb } from '../contexts';
import { Link } from 'react-router-dom';

const BreadCrumb = () => {
  const { breadcrumb } = useBreadcrumb();

  return (
    <nav className="breadcrumb-wrap" aria-label="브레드크럼">
      <ol className="breadcrumb">
        {/* 고정된 '홈' */}
        <li className="home">
          <Link to="/">
            <span className="txt">홈</span>
          </Link>
        </li>

        {/* 동적으로 업데이트되는 Breadcrumb */}
        {breadcrumb.slice(1).map((item, index) => (
          <li key={index}>
            <span className="">{item}</span>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadCrumb;
